/**
 * Componente: Confirmación de renovación de licencia. Mismo patrón que
 * ConfirmarAccionPersonalModal / ConfirmarEliminarDisenoModal /
 * ConfirmarSolicitudModal — reemplaza el confirm() nativo del navegador,
 * el único que quedaba en todo el proyecto.
 */

import React from 'react';
import { IconCerrar } from './icons';

const ConfirmarRenovacionModal = ({ nombreCompleto, procesando, onConfirmar, onCancelar }) => (
  <div className="modal-overlay">
    <div className="modal-content confirmar-eliminar-modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h2>Renovar licencia</h2>
        <button className="modal-close" onClick={onCancelar} disabled={procesando}><IconCerrar size={18} /></button>
      </div>

      <div className="modal-body">
        <p>
          {`¿Confirmás la renovación de la licencia de ${nombreCompleto}? Se registrará como fecha de emisión el día de hoy y se recalculará el vencimiento.`}
        </p>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn-cancelar" onClick={onCancelar} disabled={procesando}>
          Cancelar
        </button>
        <button type="button" className="btn-guardar" onClick={onConfirmar} disabled={procesando}>
          {procesando ? 'Renovando...' : 'Confirmar'}
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmarRenovacionModal;
